<mat-card-title class="custom-card-title text-align-center">{{ data.title | translate }}</mat-card-title>

<mat-dialog-content>
  @if (data.roles.length) {
    <ul class="functional-roles-list">
      @for (role of data.roles; track role.id) {
        <li class="functional-role-item">
          <div class="role-name">{{ role.name }}</div>
          @if (role.description) {
            <div class="role-description">{{ role.description }}</div>
          }
        </li>
      }
    </ul>
  } @else {
    <p class="empty-text">{{ 'COMMON.NO_DATA' | translate }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="close()" mat-flat-button color="primary">{{ 'COMMON.CLOSE' | translate }}</button>
</mat-dialog-actions>
